module.exports = __webpack_public_path__ + "img/ergonomics_mobilization.ef9e1706.jpg";